import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { fetchSeoMeta } from "../../lib/seoMeta";

// Accessible visible breadcrumb trail. Sourced from the same /api/seo/meta
// response that produces the BreadcrumbList JSON-LD, so the two always match.
// Renders nothing on pages without a trail (e.g. the homepage).
function toRelative(url) {
  try {
    const u = new URL(url);
    return u.pathname + u.search;
  } catch {
    return url || "/";
  }
}

export default function Breadcrumbs({ className = "" }) {
  const { pathname, search } = useLocation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchSeoMeta(pathname + (search || "")).then((d) => {
      if (!cancelled && d) setItems(d.breadcrumbs || []);
    });
    return () => { cancelled = true; };
  }, [pathname, search]);

  if (!items || items.length < 2) return null;

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={className}>
      <ol className="flex items-center flex-wrap gap-2 text-xs text-white/50">
        {items.map((b, i) => (
          <li key={i} className="flex items-center gap-2">
            {i > 0 && <ChevronRight className="h-3 w-3 text-white/30" aria-hidden="true" />}
            {b.current ? (
              <span aria-current="page" className="text-gold" data-testid="breadcrumb-current">{b.name}</span>
            ) : (
              <Link to={toRelative(b.url)} className="hover:text-white transition-colors" data-testid={`breadcrumb-link-${i}`}>{b.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
